import React from 'react';
import { useSelector } from 'react-redux';
import { CheckIcon } from 'src/components';
import { SText } from 'src/components/SText';
import { eStoreAgencyInfoSelector } from '../store';

type Props = {
  testID?: string;
};

export const EStoreSuccessSubmit: React.FC<Props> = ({ testID = 'EStoreSuccessSubmit' }) => {
  const agencyInfo = useSelector(eStoreAgencyInfoSelector);

  return (
    <div data-testid={testID} className="">
      <div className="flex flex-row justify-between items-center my-3">
        <div className="mr-1">
          <CheckIcon width={30} height={20} />
        </div>
        <div>
          <SText
            label="estore-create-success.title"
            classNames="text-primary text-2xl ml-3 block"
            translatingOptions={{ agencyName: agencyInfo?.name }}
          />
        </div>
      </div>

      <div className="mt-8">
        <SText label="estore-create-success.infos" classNames="text-2xl block mb-2 font-regular" />
        <SText label="estore-create-success.info-description" classNames="text-xl text-gray-500" />
      </div>
    </div>
  );
};
